import React, { useEffect, useState } from "react";
import Spinner from 'react-bootstrap/Spinner';
import Form from 'react-bootstrap/Form';
import Table from 'react-bootstrap/Table';
// import Button from 'react-bootstrap/Button';
import ToggleButtonGroup from 'react-bootstrap/ToggleButtonGroup';
import ToggleButton from 'react-bootstrap/ToggleButton';
import Pagination from  '../../../components/Pagination/Pagination';
import { API } from 'aws-amplify';


const DevicePerms = (props) => {
    const {
        asset,
        user,
        userUpd, 
        setUserUpd
     } = props

    // const [assetList, setAssetList] = useState([]);
    const [isLoading, setIsLoading] = useState(false);
    const [currentPage, setCurrentPage] = useState(1);
	const [itemsPerPage] = useState(10);

    const [userList, setUserList] = useState([]);
	const [users, setUsers] = useState([]);
	const [search, setSearch] = useState('');
	const [status, setStatus] = useState('');

    	// Load users
	useEffect(()=>{
        const fetchUsers = async () => {
            setIsLoading(true);
			const params = {
				headers: {
					'x-api-key': process.env.REACT_APP_API_KEY,
					'Accept': 'application/json',
					'Content-Type': 'application/json',
				},
			}

			//Get user asset list
			let user_assets = []			
			user_assets = await API.get('user_assets','/', params)

            // Filter user assets
            const assetList = user_assets
                                .filter(item => item.assets && item.assets.includes(asset))
                                .map(item => item.id)
                           
            // console.log("assetList",assetList)

            API.get('users','/', params)
            .then(res => {
                let userList = [];
                res.Users.forEach((item) => {
                    let user ={}
                    user.username = item.Username;
                    item.Attributes.forEach((e) => {
                        if (e.Name === 'name') user.name = e.Value;
                        if (e.Name === 'custom:administrator') user.admin = e.Value;
                        if (e.Name === 'custom:contractor') user.contractor = e.Value;
                    })
                    // user.status = item.UserStatus;
                    // user.date_created = <Moment local format='DD-MM-YYYY' date={ item.UserCreateDate } />;
                    // user.last_upd = <Moment local format='DD-MM-YYYY' date={ item.UserLastModifiedDate } />;
                    // user.enabled = item.Enabled;

                    if (item.Enabled)
                        userList.push(user);
                })

				if (user.profile === 'SubAdmin') 
					userList = userList.filter(i => i.contractor === user.contractor)

				
				userList = userList.map(item => ({...item, 
					profile: (user_assets.find(i => i.id === item.username) 
							&& user_assets.find(i => i.id === item.username).settings.profile ) || '',
                    checked: assetList.find(i => i === item.username) === item.username
                        }));
                
                // current users checked
                setUserUpd(userList
                                .map(item => ({username: item.username, checked: item.checked}))
                                .filter(item => item.checked === true))
                
				// console.log("userList", userList)
				userList.sort((a, b) => (a.name > b.name) ? 1 : -1)
                setUserList(userList);
                setUsers(userList);
            });

 			setIsLoading(false);
		}
		if (user.profile)
			fetchUsers();

    // eslint-disable-next-line react-hooks/exhaustive-deps
	}, [user, asset]);


	// Pagination
	  const indexOfLastItem = currentPage * itemsPerPage;
	  const indexOfFirstItem = indexOfLastItem - itemsPerPage;
	  const currentItemList = userList.slice(indexOfFirstItem, indexOfLastItem);

	  // Change page
	  const paginate = pageNumber => setCurrentPage(pageNumber);

	  useEffect(() => {
        const handleSearch = () => {
            let results = users;
            // User
            if (search){
                results = results.filter(results =>
                    (results.name && results.name.toLowerCase().includes(search.toLowerCase())) ||
                    (results.username && results.username.toLowerCase().includes(search.toLowerCase())) ||
                    (results.contractor && results.contractor.toLowerCase().includes(search.toLowerCase())))
            }
            // status
            if (status !== ''){
                results = results.filter(results =>
                    results.checked === status
            )}

            setUserList(results);
            if (results.length !== users.length)
                paginate(1);
        }
		handleSearch();
    }, [search, users, status]);

    // Find item by ID
    // const findUsrById = (id) => userUpd.find(item => item.username === id);

        // Add/Edit item 
    const editAddUsr = (id, newItem) => {
        const index = userUpd.findIndex(item => item.username === id);       
        if (index !== -1) {
            // if item exists => edit
            userUpd[index] = { ...userUpd[index], ...newItem };
        } else {
            // else => add
            userUpd.push(newItem);
        }
    };

   const handleCheckList = (e) => {
    // console.log(e.target.id, e.target.checked)
    const list = users.map(item => (item.username === e.target.id ? { ...item, checked: e.target.checked } : item))
    setUserList(list);
    setUsers(list);
    
    let action;
    if (e.target.checked){
        action = 'add'
    }else{
        action = 'rem'
    }

    const newItem = {username: e.target.id, checked: e.target.checked, action: action}
    // if (findUsrById(e.target.id)) {
    editAddUsr(e.target.id, newItem);
    //   } else {
    //     userUpd.push(newItem);
    //   }
    // console.log(userUpd)
    setUserUpd(userUpd)
}
   
return (
    <div className="col-md-12">


        <div className="row">
            <div className='col-md-6'>
                <Form.Group controlId="search">
                <Form.Control
                    as="input"
                    value={search}
                    onChange={e => {setSearch(e.target.value)}}
                    placeholder='Search by name, email or group '
                    type="text" />
                </Form.Group>
            </div>
            <div className='col-md-6'>
                <Form.Group controlId="status" className="col-md-2">
                    <ToggleButtonGroup type="radio" name="options" value={status} >
                        <ToggleButton variant="outline-secondary" className="px-2" value="" onClick={() => setStatus('')} >
                            All
                        </ToggleButton>
                        <ToggleButton variant="outline-success" className="px-2" value={true} onClick={() => setStatus(true)} >
                            Checked
                        </ToggleButton>
                        <ToggleButton variant="outline-danger" className="px-2" value={false} onClick={() => setStatus(false)} >
                            Unchecked
                        </ToggleButton>
                    </ToggleButtonGroup> 
                </Form.Group>
            </div>
        </div>
        {(!isLoading) ? (
        (currentItemList.length === 0) ? (
            <div className="col-md-12 p-4 text-center text-secondary">No records found</div>
        ):(
        <div>
            <Table size="sm" responsive hover variant="light">
            <thead>
                <tr>
                <th className='border-bottom'></th>
                <th className='border-bottom'>User</th>
                <th className='border-bottom'>Email</th>
                <th className='border-bottom'>Group</th>
                </tr>
            </thead>
            <tbody>
            {currentItemList.map((item, i) => (
            <tr key={"asset"+i} className="table-tr">
                <td className='border-bottom'>
                <Form.Check
                    inline
                    type="checkbox"
                    id={item.username}
                    checked={item.checked}
                    onChange={handleCheckList}
                    />

                </td>
                <td className='border-bottom'>{ item.name }</td>
                <td className='border-bottom'>{ item.username }</td>
                <td className='border-bottom'>{ item.contractor }</td>
            </tr>
            ))}
            </tbody>
            </Table>
            <Pagination
                sizePerPage={itemsPerPage}
                currentPage={currentPage}
                totalSize={userList.length}
                changeCurrentPage={paginate}
                theme="bootstrap"
            />
        </div>
    )):(

        <div className="col-md-12">
        <Spinner animation="grow" size="sm" role="status" variant="warning" />
        <span className="text-dark">  Loading...</span>
        </div>
    )}
</div>
)}

export default DevicePerms;